import Answer from './models'

export default Answer
